/* FlexiPod Reise – theme.js (no dependencies) */
(function () {
  'use strict';

  var d = document;
  var root = d.documentElement;
  var FP = window.FP || { routes: {}, currency: 'EUR', cartType: 'drawer' };
  var fmt = window.Intl ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: FP.currency || 'EUR' }) : null;
  function money(cents) { return fmt ? fmt.format(cents / 100) : (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function $(sel, scope) { return (scope || d).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(sel)); }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveal(scope) {
    $$('[data-reveal]:not(.is-in)', scope).forEach(function (el) {
      if (revealIO && root.classList.contains('reveal')) revealIO.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var sentinel = $('[data-scroll-sentinel]');
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-scrolled', !entries[0].isIntersecting);
      }).observe(sentinel);
    }
  }

  function setMenu(open) {
    var toggle = $('[data-menu-toggle]');
    root.classList.toggle('menu-open', open);
    root.classList.toggle('no-scroll', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    }
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnounce() {
    $$('[data-announce]').forEach(function (bar) {
      var items = $$('.announce__item', bar);
      if (items.length < 2 || bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4200);
    });
  }

  /* ---------- Delivery dates ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, dd = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - dd - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y);
    var shift = function (n) { return new Date(y, e.getMonth(), e.getDate() + n).toDateString(); };
    holidayCache[y] = [new Date(y, 0, 1).toDateString(), shift(-2), shift(1), new Date(y, 4, 1).toDateString(), shift(39), shift(50),
      new Date(y, 9, 3).toDateString(), new Date(y, 11, 25).toDateString(), new Date(y, 11, 26).toDateString()];
    return holidayCache[y];
  }
  function addWorkdays(n) {
    var dt = new Date();
    while (n > 0) {
      dt.setDate(dt.getDate() + 1);
      var wd = dt.getDay();
      if (wd !== 0 && wd !== 6 && holidays(dt.getFullYear()).indexOf(dt.toDateString()) < 0) n--;
    }
    return dt;
  }
  var dateFmt = window.Intl ? new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' }) : null;
  function initDelivery(scope) {
    if (!dateFmt) return;
    $$('[data-delivery]', scope).forEach(function (el) {
      var out = $('[data-delivery-range]', el);
      if (!out) return;
      out.textContent = dateFmt.format(addWorkdays(parseInt(el.dataset.min, 10) || 7)) + ' – ' + dateFmt.format(addWorkdays(parseInt(el.dataset.max, 10) || 14));
    });
  }

  /* ---------- Countdown (real end date from the section settings) ---------- */
  function initCountdown(scope) {
    $$('[data-countdown]', scope).forEach(function (el) {
      if (el.dataset.ready) return;
      var end = Date.parse(el.dataset.ends);
      if (isNaN(end)) return;
      el.dataset.ready = '1';
      var promo = el.closest('[data-promo]');
      var out = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { out[k] = $('[data-cd="' + k + '"]', el); });
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var timer;
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (out.d) out.d.textContent = Math.floor(left / 86400);
        if (out.h) out.h.textContent = pad(Math.floor((left % 86400) / 3600));
        if (out.m) out.m.textContent = pad(Math.floor((left % 3600) / 60));
        if (out.s) out.s.textContent = pad(left % 60);
        if (left === 0) {
          clearInterval(timer);
          if (promo && !(window.Shopify && window.Shopify.designMode)) promo.hidden = true;
        }
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    sections: ['cart-drawer'],

    drawer: function () { return $('[data-cart-drawer]'); },

    post: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw data;
          return data;
        });
      });
    },

    add: function (items) {
      return this.post(FP.routes.cartAdd + '.js', { items: items, sections: this.sections.join(','), sections_url: window.location.pathname })
        .then(function (data) {
          Cart.render(data.sections);
          Cart.bump();
          Cart.open();
          return data;
        });
    },

    change: function (line, quantity) {
      var drawer = this.drawer();
      if (drawer) drawer.classList.add('is-busy');
      return this.post(FP.routes.cartChange + '.js', { line: line, quantity: quantity, sections: this.sections.join(','), sections_url: window.location.pathname })
        .then(function (data) {
          if ($('[data-cart-page]')) { window.location.reload(); return; }
          Cart.render(data.sections);
        })
        .catch(function () { window.location.reload(); })
        .then(function () { if (drawer) drawer.classList.remove('is-busy'); });
    },

    render: function (sections) {
      if (!sections || !sections['cart-drawer']) return this.refresh();
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc);
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) {
        current.replaceWith(fresh);
        this.count(fresh.getAttribute('data-count'));
        initDelivery(fresh);
      }
    },

    refresh: function () {
      return fetch(FP.routes.root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) { Cart.render({ 'cart-drawer': html }); });
    },

    count: function (n) {
      n = parseInt(n, 10) || 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    },

    bump: function () {
      $$('[data-cart-count]').forEach(function (el) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    },

    open: function () {
      var drawer = this.drawer();
      if (FP.cartType === 'page' || !drawer) { window.location.href = FP.routes.cart; return; }
      this.lastFocus = d.activeElement;
      drawer.classList.add('is-open');
      root.classList.add('no-scroll');
      var panel = $('.drawer__panel', drawer);
      setTimeout(function () { if (panel) panel.focus(); }, 60);
    },

    close: function () {
      var drawer = this.drawer();
      if (!drawer) return;
      drawer.classList.remove('is-open');
      root.classList.remove('no-scroll');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };
  window.FPCart = Cart;

  /* ---------- Buy box ---------- */
  function initBuyBox(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var dataEl = $('[data-buybox-json]', box);
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var uid = box.id;
    var mode = box.dataset.mode;
    var form = $('[data-buybox-form]', box);
    var btn = $('[data-buybox-submit]', box);
    var label = $('[data-buybox-label]', box);
    var totalEl = $('[data-buybox-total]', box);
    var itemsBox = $('[data-buybox-items]', box);
    var errorEl = $('[data-buybox-error]', box);
    var priceEl = $('[data-price-for="' + uid + '"]');
    var compareEl = $('[data-compare-for="' + uid + '"]');
    var stickyTotal = $('[data-sticky-atc][data-for="' + uid + '"] [data-sticky-total]');
    var qtyInput = $('[data-buybox-qty]', box);
    var lastMedia = null;
    var info = box.closest('.pinfo');
    var promoBox = info && $('[data-promo-price]', info);
    var promoVal = promoBox && $('[data-promo-value]', promoBox);
    var promoPct = promoBox ? parseFloat(promoBox.dataset.pct) || 0 : 0;

    function checked(name) {
      var r = $('input[name="' + name + '"]:checked', form);
      return r ? r.value : null;
    }
    function byColor(val) {
      for (var i = 0; i < D.variants.length; i++) if (D.variants[i].options[0] === val) return D.variants[i];
      return D.variants[0];
    }
    function byOptions() {
      var picked = $$('[data-option]', form).map(function (fs) { return checked(uid + '-o' + fs.dataset.option); });
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i], ok = true;
        for (var j = 0; j < picked.length; j++) if (picked[j] !== null && v.options[j] !== picked[j]) ok = false;
        if (ok) return v;
      }
      return null;
    }
    function addons() {
      return $$('[data-addon]', box).filter(function (a) {
        return $('[data-addon-toggle]', a).checked;
      }).map(function (a) {
        var sel = $('[data-addon-variant]', a);
        var opt = sel.options[sel.selectedIndex];
        return { id: parseInt(sel.value, 10), price: parseInt(opt.getAttribute('data-price'), 10) || 0, available: !opt.disabled, tracked: false, qty: 1 };
      });
    }
    function group(list) {
      var map = {}, order = [];
      list.forEach(function (v) {
        if (!map[v.id]) { map[v.id] = { v: v, quantity: 0 }; order.push(v.id); }
        map[v.id].quantity += (v.qty || 1);
      });
      return order.map(function (id) { return map[id]; });
    }

    function state() {
      var main = [], isSet = false, variant = null;
      if (mode === 'bundle') {
        isSet = checked(uid + '-pack') === '2';
        variant = byColor(checked(uid + '-c1'));
        main.push(variant);
        if (isSet) main.push(byColor(checked(uid + '-c2')) || variant);
      } else {
        variant = byOptions();
        var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        if (variant) main.push({ id: variant.id, price: variant.price, available: variant.available, tracked: variant.tracked, q: variant.q, qty: q });
      }
      var extra = addons();
      var all = main.concat(extra);
      var lines = group(all);
      var ok = !!variant && lines.every(function (l) { return l.v.available && (!l.v.tracked || l.v.q >= l.quantity); });
      var total = all.reduce(function (s, v) { return s + v.price * (v.qty || 1); }, 0) - (isSet ? D.save : 0);
      return { variant: variant, lines: lines, ok: ok, total: total, isSet: isSet, extra: extra.length };
    }

    function sync() {
      var s = state();
      var v = s.variant;

      if (mode === 'bundle') {
        var slot2 = $('[data-slot="2"]', box);
        var t1 = $('[data-slot-title="1"]', box);
        if (slot2) slot2.hidden = !s.isSet;
        if (t1) t1.textContent = t1.textContent.replace(/\s·\sStück 1$/, '') + (s.isSet ? ' · Stück 1' : '');
        [1, 2].forEach(function (n) {
          var out = $('[data-slot-value="' + n + '"]', box);
          if (out) out.textContent = checked(uid + '-c' + n) || '';
        });
      } else {
        $$('[data-option]', form).forEach(function (fs) {
          var out = $('[data-option-value="' + fs.dataset.option + '"]', box);
          if (out) out.textContent = checked(uid + '-o' + fs.dataset.option) || '';
        });
        if (v) {
          if (priceEl) priceEl.textContent = money(v.price);
          if (promoVal) promoVal.textContent = money(v.price - Math.round(v.price * promoPct / 100));
          if (compareEl) {
            compareEl.hidden = !(v.compare > v.price);
            if (v.compare > v.price) compareEl.textContent = money(v.compare);
          }
          if (window.history && window.history.replaceState && box.closest('.section-main-product')) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      }

      itemsBox.innerHTML = s.lines.map(function (l, i) {
        return '<input type="hidden" name="items[' + i + '][id]" value="' + l.v.id + '">' +
               '<input type="hidden" name="items[' + i + '][quantity]" value="' + l.quantity + '">';
      }).join('');

      btn.disabled = !s.ok;
      if (!v || !v.available) label.textContent = D.labels.soldout;
      else if (!s.ok) label.textContent = D.labels.stock;
      else label.textContent = s.isSet ? D.labels.addSet : D.labels.add;
      if (totalEl) totalEl.textContent = money(s.total);
      if (stickyTotal) stickyTotal.textContent = money(s.total) + (s.isSet ? ' · 2er-Set' : '');

      if (v && v.media && v.media !== lastMedia) {
        lastMedia = v.media;
        box.dispatchEvent(new CustomEvent('fp:media', { bubbles: true, detail: { uid: uid, media: v.media } }));
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-addon-variant]')) {
        var t = $('[data-addon-toggle]', e.target.closest('[data-addon]'));
        if (t) t.checked = true;
      }
      if (errorEl) errorEl.hidden = true;
      sync();
    });
    box.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step || !qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
      sync();
    });
    if (qtyInput) qtyInput.addEventListener('input', sync);

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var s = state();
      if (!s.ok || btn.disabled) return;
      btn.disabled = true;
      label.textContent = D.labels.adding;
      Cart.add(s.lines.map(function (l) { return { id: l.v.id, quantity: l.quantity }; }))
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && (err.description || err.message)) || D.labels.error;
            errorEl.hidden = false;
          }
        })
        .then(function () { btn.disabled = false; sync(); });
    });

    sync();
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    var track = $('[data-gallery-track]', g);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', g);
    var current = $('[data-gallery-current]', g);
    var idx = 0, timer;

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark(i) {
      idx = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (current) current.textContent = i + 1;
      var at = thumbs[i];
      if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) {
        at.parentNode.scrollTo({ left: at.offsetLeft - at.parentNode.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
      }
    }
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.galleryThumb, 10)); }); });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1 >= slides.length ? 0 : idx + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    d.addEventListener('fp:media', function (e) {
      if (e.detail.uid !== g.dataset.for) return;
      var target = $('[data-media-id="' + e.detail.media + '"]', track);
      if (target) go(parseInt(target.dataset.index, 10));
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    if (bar.dataset.ready || !('IntersectionObserver' in window)) return;
    bar.dataset.ready = '1';
    var box = d.getElementById(bar.dataset.for);
    var anchor = box && $('[data-atc-anchor]', box);
    if (!anchor) return;
    var footer = $('.section-footer');
    var anchorOut = false, footerIn = false;
    function update() {
      var show = anchorOut && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = $('[data-sticky-buy]', bar);
      if (b) b.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      anchorOut = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }).observe(anchor);
    if (footer) new IntersectionObserver(function (entries) { footerIn = entries[0].isIntersecting; update(); }).observe(footer);
    $('[data-sticky-buy]', bar).addEventListener('click', function () {
      var form = $('[data-buybox-form]', box);
      if (form.requestSubmit) form.requestSubmit(); else $('[data-buybox-submit]', box).click();
    });
  }

  /* ---------- Sliders ---------- */
  function slideBy(id, dir) {
    var track = d.getElementById(id);
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  /* ---------- Global events ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-menu-toggle]'))) { setMenu(!root.classList.contains('menu-open')); return; }
    if (root.classList.contains('menu-open') && t.closest('.mobile-menu a')) setMenu(false);

    if ((el = t.closest('[data-cart-open]')) && FP.cartType !== 'page' && Cart.drawer()) { e.preventDefault(); setMenu(false); Cart.open(); return; }
    if (t.closest('[data-cart-close]')) { Cart.close(); return; }

    if ((el = t.closest('[data-cart-qty]'))) {
      Cart.change(parseInt(el.dataset.line, 10), Math.max(0, parseInt(el.dataset.qty, 10)));
      return;
    }
    if ((el = t.closest('[data-cart-add]'))) {
      el.disabled = true;
      Cart.add([{ id: parseInt(el.dataset.cartAdd, 10), quantity: 1 }]).catch(function () { el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-upsell-add]'))) {
      var wrap = el.closest('[data-upsell]');
      var sel = wrap && $('[data-upsell-variant]', wrap);
      el.disabled = true;
      Cart.add([{ id: parseInt(sel ? sel.value : el.dataset.variant, 10), quantity: 1 }]).catch(function () { el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-slider-prev]'))) { slideBy(el.dataset.sliderPrev, -1); return; }
    if ((el = t.closest('[data-slider-next]'))) { slideBy(el.dataset.sliderNext, 1); return; }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('menu-open')) setMenu(false);
    var drawer = Cart.drawer();
    if (drawer && drawer.classList.contains('is-open')) Cart.close();
  });

  /* ---------- Init ---------- */
  function init(scope) {
    initReveal(scope);
    initAnnounce();
    initDelivery(scope);
    initCountdown(scope);
    $$('[data-promo-price][data-ends]', scope).forEach(function (el) {
      var end = Date.parse(el.dataset.ends);
      if (!isNaN(end) && Date.now() > end) el.hidden = true;
    });
    $$('[data-buybox]', scope).forEach(initBuyBox);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-sticky-atc]', scope).forEach(initSticky);
  }

  function boot() {
    initHeader();
    init(d);
    window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  d.addEventListener('shopify:section:load', function (e) {
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
    init(e.target);
  });
})();
